import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

export const PublicRoute = ({ isAuthenticated }) => {
    const location = useLocation();

    // Si el usuario intenta ir al login pero ya está autenticado → redirigir al dashboard
    if (location.pathname === '/login' && isAuthenticated) {
        return <Navigate to="/dashboard" replace />;
    }

    // En cualquier otro caso, renderiza las rutas hijas normalmente
    return <Outlet />;
};

PublicRoute.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
};
